import { ACTION_TYPES } from './_actionTypes';

/**
 * Action creator for initializing new state and updating existing state within the existing store.
 * @param {Object} value properties to be added to or updated in the existing store.
 * @returns {Object} dispatched action.
 */
export const init = value => {
	return {
		type: ACTION_TYPES.PENDING_APPROVALS_INIT,
		payload: value,
	};
};

/**
 * Action creator for setting `rows` state.
 * @param {Object[]} rows nullable array of `DataTable` `row` objects.
 * @param {string} searchValue nullable value to filter against.
 * @param {string[]} filterValue array of chip IDs used to handle sorting.
 * @returns {Object} dispatched action.
 */
export const setRows = (rows, searchValue, filterValue) => {
	return {
		type: ACTION_TYPES.PENDING_APPROVALS_SET_ROWS,
		payload: {
			rows,
			searchValue,
			filterValue,
		},
	};
};

/**
 * Action creator for toggling @param row in `requestees`, `rows` state.
 * @param {Object} row `DataTable` `row` object of interest.
 * @returns {Object} dispatched action.
 */
export const toggleRow = row => {
	return {
		type: ACTION_TYPES.PENDING_APPROVALS_TOGGLE_ROW,
		payload: row,
	};
};

/**
 * Action creator for toggling all `requestees`, `rows` state against @param event .
 * @param {Event} e event object of change.
 * @param {Number} index index of action firing change in `actions` state.
 * @returns {Object} dispatched action.
 */
export const toggleAll = (e, index) => {
	return {
		type: ACTION_TYPES.PENDING_APPROVALS_TOGGLE_ALL,
		payload: {
			e,
			index,
		},
	};
};

/**
 * Action creator for performing index search on `rows` state.
 * @param {String} value nullable value to filter against.
 * @returns {Object} dispatched action.
 */
export const indexRows = value => {
	return {
		type: ACTION_TYPES.PENDING_APPROVALS_SEARCH_INDEX,
		payload: value,
	};
};

/**
 * Action creator for sorting `rows` state.
 * @param {String} header `Value` property of `headers` state's element of interest.
 * @param {Number} sortOrder nullable direction of sort; 1 for ascending, -1 for descending, null for no sort.
 * @returns {Object} dispatched action.
 */
export const sortByHeader = (header, sortOrder) => {
	return {
		type: ACTION_TYPES.PENDING_APPROVALS_SORT_BY_HEADER,
		payload: {
			header,
			sortOrder,
		},
	};
};

/**
 * Action creator for filtering based on user selection.
 * @param {string[]} filter array of chip IDs used to handle sorting.
 * @returns
 */
export const filterByUser = filter => {
	return {
		type: ACTION_TYPES.PENDING_APPROVALS_FILTER_BY_USER,
		payload: filter,
	};
};
